import React, { Component } from 'react';
import { Form, Icon, Select, Modal, Button,Segment, Grid, Message } from 'semantic-ui-react';
import { fetchSKPD, getSKPD, getOPD } from '../../../../../_utils/localstorage';
import { BaseURLDev, headers } from '../../../../../_utils/config';
import moment from 'moment'
import printJS from 'print-js';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import { DateRangePicker,isInclusivelyBeforeDay } from 'react-dates';
import { toIDR } from '../../../../../_utils/tocurrency';
import jsPDF from 'jspdf'
import { terbilang } from '../../../../../_utils/terbilang';
import { filterOPD } from '../../../../../_utils/getrekening';
import swal from 'sweetalert';

export default class ExportModal extends Component {

   constructor(props){
      super(props)
      this.state = {
         skpds: [],
         opd_select: [],
         data: [],
         filter: {},
         focused: null,
         focusedInput: null,
         
         startDate: null,
         endDate: null,
         status_val: null,
         skpd_val: null,
         opd_val: null,
         
         dataSource: [],

         total_all: 0,
         count_unverified: 0,
         count_verified: 0,
         export_process: false,
         disabled_opd: true,
         status_opd: false
      }

      this.onChangeSKPD = this.onChangeSKPD.bind(this);
      this.onChangeOPD = this.onChangeOPD.bind(this);
      this.onChangeStatus = this.onChangeStatus.bind(this);
      this.exportMode = this.exportMode.bind(this);
      this.exportToPDF = this.exportToPDF.bind(this);
   }

   getDataSKPD(){
      fetch(`${BaseURLDev}/simantra/ref/allskpd`)
      .then(response => {
         if(!response.ok){
            return Promise.reject(response.statusText);
         }
         return response.json()
      })
      .then(resJSON => {
         var { opd, user } = JSON.parse(sessionStorage.data);
         sessionStorage.setItem('data', JSON.stringify({
            user: user,
            opd: opd,
            skpd: resJSON.data,
         }))
         
         const skpds = []
         skpds.push({'value':10000,'text':"Semua SKPD",'key':0})
         for(let i=0; i<resJSON.data.length; i++) {
            skpds.push({
               'value': i+1,
               'text': `[${resJSON.data[i].kode_skpd}] ${resJSON.data[i].skpd}`,
               'key': resJSON.data[i].kode_skpd,     
            })
         }
         this.setState({skpds:skpds})
      })
   }

   skpdSelect(){
      if(fetchSKPD().length!==0){
         const skpds = []
         skpds.push({'value':10000,'text':"Semua SKPD",'key':0})
         
         for(let i=0; i<fetchSKPD().length; i++) {
            skpds.push({
               'value': i+1,
               'text': `[${fetchSKPD()[i].kode_skpd}] ${fetchSKPD()[i].skpd}`,
               'key': fetchSKPD()[i].kode_skpd,     
            })
         }
         
         this.setState({skpds:skpds})
      }
   }

   componentDidMount(){
      if(fetchSKPD().length===0){
         this.getDataSKPD()
      }else{
         this.skpdSelect();
      }
   }

   filterData(opt){
      const { startDate,endDate,status_val,skpd_val,opd_val } = this.state
      
      const start_date = startDate===null ? null : startDate.format('YYYY-MM-DD')
      const end_date = endDate===null ? null : endDate.format('YYYY-MM-DD')

      fetch(`${BaseURLDev}/report/sts/export?start=${start_date}&end=${end_date}&status=${status_val}&skpd=${skpd_val}&opd=${opd_val}`, { headers })
      .then(response => {
         if(!response.ok){
            this.setState({export_process:false})
            swal("Filter data gagal, periksa koneksi internet anda", {
               icon: "error",
            });
            return Promise.reject(response.statusText);
         }
         return response.json()
      })
      .then(resJSON => {
         if(resJSON.data.length===0){
            this.setState({export_process:false})
            swal("Data tidak ditemukan", {
               icon: "error",
            });
         }else{
            
            if(resJSON.skpd===null) this.setState({data:resJSON.data,rentang:resJSON.rentang})
            else this.setState({data:resJSON.data, is_skpd:resJSON.skpd,rentang:resJSON.rentang})

            if(opt==='excel') this.exportMode().toCSV('sts_id',`${moment().format("DD_MM_YYYY_HH_mm_ss")}`)
            
            else if(opt==='pdf') this.exportToPDF(`${moment().format("DD_MM_YYYY_HH_mm_ss")}`)

            else{
               printJS({
                  printable: 'data_print',
                  type: 'html',
                  modalMessage:"Sedang memuat data...",
                  showModal:true,
                  maxWidth:'1300',
                  font_size:'8pt',
                  documentTitle:`${moment().format('DD-MM-YYYY--HH:mm:ss')}`,
                  targetStyle: [
                     'margin',
                     'color',
                     'border-collapse',
                     'border-spacing',
                     'border-style',
                     'border-style',
                     'margin-bottom',
                     'background',
                     'padding'
                  ]
               })
            }

            this.setState({export_process:false})
         }
      })
   }

   onChangeSKPD(e,el){
      this.setState({status_opd:true})
      if(el.value!==10000){
         const skpd = (el.options[el.value].key).split(".");
         filterOPD(skpd[0],skpd[1],skpd[2])
         .then(resJSON=> {
            this.setState({
               skpd_val:el.options[el.value].key,
               opd_select:resJSON.data,
               opd_val:null,
               status_opd:false
            })
         });
      }else{
         this.setState({status_opd:false,skpd_val:el.value,opd_select:[]})         
      }
      // this.setState({status_opd:false})
   }

   onChangeOPD(e,el){
      // if(el.value!==10000){
      this.setState({opd_val:el.value})
      // }else{
      //    this.setState({opd_val:null})         
      // }
   }

   onChangeStatus(e,el){
      // if(el.value!==0){
      this.setState({status_val:el.value})
      // }else{
      //    this.setState({status_val:null})
      // }
   }
   
   exportToPDF() {
      var pdf = new jsPDF('p', 'pt', 'letter');
         var source = document.getElementById("print_data");
         var specialElementHandlers = {
               '#bypassme': function (element, renderer) {
                  return true
               }
         };
         var margins = {
               top: 80,
               bottom: 60,
               left: 40,
               width: 522
         };
       
      pdf.fromHTML(
         source, // HTML string or DOM elem ref.
         margins.left, // x coord
         margins.top, { // y coord
               'width': margins.width, // max width of content on PDF
               'elementHandlers': specialElementHandlers
         },

         function (dispose) {
               pdf.save('Test.pdf');
         }, margins
      );
   }

   exportMode(){
      return {
         _fallbacktoCSV: true,  
         toXLS: function(tableId, filename) {   
            this._filename = (typeof filename === 'undefined') ? tableId : filename;
            if ((this._getMsieVersion() || this._isFirefox()) && this._fallbacktoCSV) {
               return this.toCSV(tableId);
            } else if (this._getMsieVersion() || this._isFirefox()) {
               alert("Not supported browser");
            }

            //Other Browser can download xls
            var htmltable = document.getElementById(tableId);
            var html = htmltable.outerHTML;

            this._downloadAnchor("data:application/vnd.ms-excel" + encodeURIComponent(html), 'xls'); 
         },
         toCSV: function(tableId, filename) {
            this._filename = (typeof filename === 'undefined') ? tableId : filename;
            // Generate our CSV string from out HTML Table
            var csv = this._tableToCSV(document.getElementById(tableId));
            // Create a CSV Blob
            var blob = new Blob([csv], { type: "text/csv" });

            // Determine which approach to take for the download
            if (navigator.msSaveOrOpenBlob) {
               // Works for Internet Explorer and Microsoft Edge
               navigator.msSaveOrOpenBlob(blob, this._filename + ".csv");
            } else {      
               this._downloadAnchor(URL.createObjectURL(blob), 'csv');      
            }
         },
         toPDF: function(tableId, filename) {
            this._filename = (typeof filename === 'undefined') ? tableId : filename;
            // Generate our CSV string from out HTML Table
            var pdf = document.getElementById(tableId);
            // Create a CSV Blob
            var blob = new Blob([pdf], { type: "text/pdf" });

            // Determine which approach to take for the download
            if (navigator.msSaveOrOpenBlob) {
               // Works for Internet Explorer and Microsoft Edge
               navigator.msSaveOrOpenBlob(blob, this._filename + ".pdf");
            } else {      
               this._downloadAnchor(URL.createObjectURL(blob), 'pdf');      
            }
         },
         _getMsieVersion: function() {
            var ua = window.navigator.userAgent;

            var msie = ua.indexOf("MSIE ");
            if (msie > 0) {
               // IE 10 or older => return version number
               return parseInt(ua.substring(msie + 5, ua.indexOf(".", msie)), 10);
            }

            var trident = ua.indexOf("Trident/");
            if (trident > 0) {
               // IE 11 => return version number
               var rv = ua.indexOf("rv:");
               return parseInt(ua.substring(rv + 3, ua.indexOf(".", rv)), 10);
            }

            var edge = ua.indexOf("Edge/");
            if (edge > 0) {
               // Edge (IE 12+) => return version number
               return parseInt(ua.substring(edge + 5, ua.indexOf(".", edge)), 10);
            }

            // other browser
            return false;
         },
         _isFirefox: function(){
            if (navigator.userAgent.indexOf("Firefox") > 0) {
               return 1;
            }

            return 0;
         },
         _downloadAnchor: function(content, ext) {
            var anchor = document.createElement("a");
            anchor.style = "display:none !important";
            anchor.id = "downloadanchor";
            document.body.appendChild(anchor);

            // If the [download] attribute is supported, try to use it
            if ("download" in anchor) {
               anchor.download = this._filename + "." + ext;
            }
            anchor.href = content;
            anchor.click();
            anchor.remove();
         },
         _tableToCSV: function(table) {
            // We'll be co-opting `slice` to create arrays
            var slice = Array.prototype.slice;

            return slice
            .call(table.rows)
            .map(function(row) {
               return slice
               .call(row.cells)
               .map(function(cell) {
                  return '"t"'.replace("t", cell.textContent);
               })
               .join(",");
            })
            .join("\r\n");
         }
      }
  }

   render() {
      
      const verifikasi = [
         {'key': 0, 'text': 'Semua status', 'value': 10000},
         {'key': 1, 'text': 'Realisasi', 'value': 1},
         {'key': 2, 'text': 'STS', 'value': 0}
      ]
  
      const styletb = {
         borderCollapse:'collapse',
         borderSpacing:0,
         borderStyle:'solid',
         width:'100%',
      }

      var total_all = 0
      var total_realisasi = 0
      var total_sts = 0
      if(this.state.data.length>1){
         this.state.data.map(function(item){
            item.bp.map(function(bp){
               bp.rincian.map(function(rincian){
                  total_all += rincian.nilai 
                  if(item.is_verified){
                     total_realisasi += rincian.nilai  
                  }else{
                     total_sts += rincian.nilai  
                  } 
               })
            })
         })
      }
      return (
         
         <div>
            <Modal
               open={this.props.open}
               onClose={this.props.onClose}
               closeOnEscape={false}
               closeOnRootNodeClick={false}
               size="tiny"
            >
               <Modal.Header>
                  Export data
               </Modal.Header>
               
               <Modal.Content>
                  <Grid>
                     <Grid.Column width={16}>
                        <Segment loading={this.state.export_process}>
                           
                           <p style={{marginBottom:'1px'}}>Rentang data yang akan diprint</p>
                           <DateRangePicker
                              verticalSpacing={7}
                              block
                              hideKeyboardShortcutsPanel
                              reopenPickerOnClearDates
                              showClearDates
                              showDefaultInputIcon
                              minimumNights={0}
                              displayFormat="DD/MM/YYYY"
                              small={true}                              
                              numberOfMonths={2}
                              startDatePlaceholderText="Awal"
                              endDatePlaceholderText="Akhir"
                              startDateId="startDateId"
                              endDateId="endDateId"
                              isOutsideRange={day => !isInclusivelyBeforeDay(day, moment())}
                              startDate={this.state.startDate}
                              endDate={this.state.endDate}
                              onDatesChange={({ startDate, endDate }) => this.setState({ startDate, endDate })}
                              focusedInput={this.state.focusedInput}
                              onFocusChange={(focusedInput) => this.setState({ focusedInput })}
                           />
                           <Form>
                              <p style={{marginTop:'20px', marginBottom:'1px'}}> Pilih status</p>
                              <Form.Field
                                 style={{marginBottom:'6px'}}
                                 control={Select} 
                                 search          
                                 options={verifikasi}
                                 onChange={this.onChangeStatus} 
                              />
                              <p style={{marginBottom:'1px'}}>Pilih SKPD</p>                              
                              <Form.Field
                                 style={{marginTop:'1px', marginBottom:'10px'}}
                                 control={Select} 
                                 search          
                                 options={this.state.skpds}
                                 onChange={this.onChangeSKPD} 
                              />

                              <p style={{marginBottom:'1px'}}>Pilih OPD</p>                              
                              
                              <Form.Field loading={this.state.status_opd}
                                 style={{marginTop:'1px', marginBottom:'10px'}}
                                 control={Select} 
                                 search   
                                 disabled={this.state.status_opd}       
                                 options={this.state.opd_select}
                                 onChange={this.onChangeOPD} 
                              />
                           
                           </Form>
                           
                           <Message
                              error
                              header='** Penting!'
                              content='Jika (*rentang tanggal dikosongkan maka akan mengembalikan data hari ini'
                           />
                        </Segment>
                     </Grid.Column>                        
                  </Grid>
               </Modal.Content>
               <Modal.Actions>
                  <Button color='blue' onClick={()=>this.filterData('print')}>
                     <Icon name='print' className='left floated' />
                     Preview
                  </Button>  
                  
                  <Button negative onClick={this.props.onClose}>Tutup</Button>                        
               </Modal.Actions>
               <div id="data_print" style={{height:0,width:'100%',overflow: 'hidden'}}>
                  <style dangerouslySetInnerHTML={{__html: `
                     @page{
                        size: 8.5in 14in;
                        margin: default;
                     }
                  `}} /><div id="print_data">
                  <table align="center" width="100%" style={{fontSize:'14px'}}>
                     <tbody>
                        <tr align="center">
                           <th colSpan="4">
                              <p style={{fontSize:'18px',marginBottom: '25px'}}>PEMERINTAH PROVINSI NUSA TENGGARA BARAT<br />
                              REKAPITULASI SURAT TANDA SETORAN (STS)</p>
                           </th>
                        </tr>
                        <tr>
                           <td align="left">SKPD</td>
                           <td align="left">&nbsp;:&nbsp;{
                              this.state.is_skpd!==null ? getSKPD(this.state.is_skpd) : "Semua SKPD"
                           }</td>
                           <td align="right"width="30%">Realisasi</td>
                           <td align="left">&nbsp;:&nbsp;{toIDR(total_realisasi)}</td>
                        </tr>
                        <tr>
                           <td align="left">Tanggal</td>
                           <td align="left">&nbsp;:&nbsp;{moment().format("DD/MM/YYYY HH:mm:ss")}</td>
                           <td align="right">STS</td>
                           <td align="left">&nbsp;:&nbsp;{toIDR(total_sts)}</td>
                        </tr>
                        <tr>
                           <td align="left">Terbilang</td>
                           <td align="left">&nbsp;:&nbsp;{terbilang(total_all)}</td>
                           <td align="right">Total</td>
                           <td align="left">&nbsp;:&nbsp;{toIDR(total_all)}</td>
                        </tr>
                        <tr>
                           <td colSpan="4"><b><i>Rentang waktu {this.state.rentang} denga rincian STS sebagai berikut</i></b> :</td>
                        </tr>
                     </tbody>
                  </table>
                  <table border="1" style={styletb} id="sts_id" align="center" width="100%">
                     <tbody>            
                        <tr style={{background:'#e5e5e5',padding:'4px'}}>
                           <th style={{padding:'4px'}}>No.</th>
                           <th style={{padding:'4px'}}>SKPD</th>
                           <th style={{padding:'4px'}}>OPD</th>
                           <th style={{padding:'4px'}}>STS</th>
                           <th style={{padding:'4px'}}>Realisasi</th>
                           <th style={{padding:'4px'}}>No. STS</th>
                           <th style={{padding:'4px'}}>Rekening</th>
                           <th style={{padding:'4px'}}>Total</th>
                        </tr>
                        {this.state.data.map((item,i)=>{

                           return(<tr key={i}>
                              <td style={{padding:'4px'}}>{i+1}</td>
                              <td style={{padding:'4px'}}>{getSKPD(item.skpd_str)}</td>
                              <td style={{padding:'4px'}}>{getOPD(item.opd_str)}</td>
                              <td style={{padding:'4px'}}>{moment(item.created_at).format("DD/MM/YYYY")}</td>
                              <td style={{padding:'4px'}}>{
                                 item.updated_at===null ? "STS":moment(item.tgl_realisasi).format("DD/MM/YYYY")
                              }</td>
                              <td style={{padding:'4px'}}>{item.no_sts}</td>
                              <RekeningRincian data={item.bp} />
                              <RekeningTotal data={item.bp} />
                           </tr>)
                        })}
                     </tbody>            
                  </table></div>
               </div>
            </Modal>
         </div>
      );
   }
}

const RekeningRincian = (props) => {
      return(
         <td style={{paddingLeft:'0px',paddingRight:'2px'}}>
            <ol type="a" style={{paddingLeft:'18px'}}>
               {props.data.map((item,i)=>(
                  item.rincian.map((rek,ii)=>(
                        <li key={ii}>                     
                           {
                              <span>
                                 {rek.kd_rek_1}.{rek.kd_rek_2}.{rek.kd_rek_3}.{rek.kd_rek_4}.{rek.kd_rek_5}.{rek.kd_rek_6}
                                 <ul type="square" style={{paddingLeft:'25px'}}>
                                    <li>{toIDR(rek.nilai)}</li>
                                    <li>{rek.uraian_rinc}</li>
                                 </ul>
                              </span>
                           }
                        </li>
                     ))
                  ))
               }
            </ol>
         </td>
      )
   }

const RekeningTotal = (props) => {
   var count = 0
   props.data.map((item,i)=>(
      item.rincian.map((rek,ii)=>(
         count = count + rek.nilai
   ))))
   return(
         <td style={{padding:'4px'}}>{toIDR(count)}</td>
   )
}


// WEBPACK FOOTER //
// ./src/components/Content/views/admin/_sts/ExportModal.js